import { useToast } from '@chakra-ui/react';
import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { getOccurrenceById, getOccurrences } from '~/services';
import { OccurrenceListView, OccurrenceView, Pagination } from '~/types';
import { QueryFilterContext } from '~/hooks/useFilter/types';
import { PAGE_SIZE } from '~/constants';

export function useOccurrences(
  page: number,
  orderby = '',
  order = '',
  search = '',
  query: QueryFilterContext,
  pageSize = PAGE_SIZE,
  options: UseQueryOptions<Pagination<OccurrenceListView>, unknown> = {},
): UseQueryResult<Pagination<OccurrenceListView>, unknown> {
  const arrGroups = query.groups?.map(e => e.value);
  const arrHeadOffices = query.headOffices?.map(e => e.value);
  const arrBrancches = query.branches?.map(e => e.value);

  return useQuery<Pagination<OccurrenceListView>, unknown>(
    [
      'occurrences',
      page,
      orderby,
      order,
      { arrGroups, arrHeadOffices, arrBrancches },
      pageSize,
      search,
    ],
    () =>
      getOccurrences(
        page,
        orderby,
        order,
        search,
        {
          groups: arrGroups,
          headoffices: arrHeadOffices,
          branches: arrBrancches,
        },
        pageSize,
      ),
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
      ...options,
    },
  );
}

export function useOccurrenceById(
  id: string,
  options: UseQueryOptions<OccurrenceView, unknown> = {},
): UseQueryResult<OccurrenceView, unknown> {
  const toast = useToast();

  return useQuery<OccurrenceView, unknown>(
    ['occurrence', id],
    () => getOccurrenceById(id),
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
      ...options,
      onError: () => {
        toast({
          title: 'Erro',
          description: 'Erro ao obter dados, tente novamente',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      },
    },
  );
}
